@if (!item.hidden) {
    <!-- item.url -->
    @if (item.url && !item.externalUrl && !item.function) {
        <a
            class="nav-link"
            [ngClass]="item.classes"
            [routerLink]="[item.url]"
            [routerLinkActive]="['active', 'accent']"
            [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
            [target]="item.openInNewTab ? '_blank' : '_self'"
        >
            <ng-container *ngTemplateOutlet="itemContent"></ng-container>
        </a>
    }
    <!-- item.externalUrl -->
    @if (item.url && item.externalUrl && !item.function) {
        <a
            class="nav-link"
            [ngClass]="item.classes"
            [href]="item.url"
            [target]="item.openInNewTab ? '_blank' : '_self'"
        >
            <ng-container *ngTemplateOutlet="itemContent"></ng-container>
        </a>
    }
    <!-- item.function -->
    <!-- <span class="nav-link" [ngClass]="item.classes" *ngIf="!item.url && item.function"
  (click)="item.function()">
  <ng-container *ngTemplateOutlet="itemContent"></ng-container>{{item.function}}
</span> -->
    @if (!item.url && item.function) {
        <span class="nav-link" [ngClass]="item.classes" (click)="runFunction(item.function)">
            <ng-container *ngTemplateOutlet="itemContent"></ng-container>
        </span>
    }
    <!-- item.url && item.function -->
    @if (item.url && !item.externalUrl && item.function) {
        <a
            class="nav-link"
            [ngClass]="item.classes"
            (click)="item.function()"
            [routerLink]="[item.url]"
            [routerLinkActive]="['active', 'accent']"
            [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
            [target]="item.openInNewTab ? '_blank' : '_self'"
        >
            <ng-container *ngTemplateOutlet="itemContent"></ng-container>
        </a>
    }
    <!-- item.externalUrl && item.function -->
    @if (item.url && item.externalUrl && item.function) {
        <a
            class="nav-link"
            [ngClass]="item.classes"
            (click)="item.function()"
            [href]="item.url"
            [target]="item.openInNewTab ? '_blank' : '_self'"
        >
            <ng-container *ngTemplateOutlet="itemContent"></ng-container>
        </a>
    }
    <ng-template #itemContent>
        @if (item.badge) {
            <span
                class="badge-left"
                [translate]="item.badge.translate"
                [ngStyle]="{ 'background-color': item.badge.bg, color: item.badge.fg }"
            >
                {{ item.badge.title }}
            </span>
        }
        @if (item.iconType === "icon" && item.icon) {
            <mat-icon class="nav-link-icon">{{ item.icon }}</mat-icon>
        }
        @if (item.iconType === "img" && item.icon) {
            <img class="nav-link-icon" [src]="item.icon" />
        }
        <span class="nav-link-title" [translate]="item.translate">{{
            (item.translate | translate) || item.title
        }}</span>
    </ng-template>
}
